<!--<div [class.server-loader-hidden]="!showLoader" class="server-loader-overlay">-->
<!--  <div class="server-loader">-->
<!--    <div class="lds-dual-ring"></div>-->
<!--  </div>-->
<!--</div>-->
<!-- <app-status-loading-full-page *ngIf="showLoader"></app-status-loading-full-page> -->

<div style="width: 100%; margin: 0 auto;" [class.d-none]="showLoader">
  <div class="container">
    <div class="wrapper">
      <article>
        <span class="title mb-5"><i class="fa fa-cog cursor-pointer" (click)="toggleShowServerSelect()"></i>&nbsp;We&rsquo;ll be back soon!</span>
        <span class="logo mb-5 d-flex justify-content-center">
          <img src="https://files.sokrates.co.id/pri/image/tenant/logo/9b00f263-7bae-4643-ac77-9bff22183e0d.png"
               alt="sokrates logo">
        </span>
        <div class="mt-5 mb-5">
          <p>Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. If you need to you
            can always <a href="mailto:sokrates@binus.edu">contact us</a>, otherwise we&rsquo;ll be back online shortly!
          </p>
        </div>
        <div class="form-group mt-5 mb-5" [class.d-none]="!serverSelectShown">
          <div class="input-group mb-3">
            <input class="form-control"
                   (keydown.enter)="onSubmit()"
                   id="input-domain"
                   name="input-domain"
                   placeholder="API FQDN"
                   type="text" [(ngModel)]="fqdn">
            <div class="input-group-append">
              <button class="btn button-sokrates btn-primary" type="submit" (click)="onSubmit()">
                <i class='fa fa-circle-o-notch fa-spin' *ngIf="loadingFqdn"></i>
                <span *ngIf="!loadingFqdn">Go</span>
              </button>
            </div>
          </div>
          <div class="text-danger">
            <span *ngIf="error === 'required'">Please enter Fully Qualified Domain Name</span>
            <span *ngIf="error === 'fqdnIsNotRegistered'">Domain is not registered!</span>
            <span *ngIf="error === 'HttpErrorResponse'">Http failure response for (unknown url): 0 Unknown Error</span>
          </div>
        </div>
        <div class="mt-5 text-muted text-center border-top-0">
          <small>Powered by <b><a href="https://sokrates.id" target="_blank">Sokrates</a></b></small>
          <br>
          <small>
            <a href="https://changelog.sokrates.co.id" target="_blank">v1.0.0</a>
          </small>
        </div>
      </article>
    </div>
  </div>
</div>
